import { ElementRef, Injectable } from '@angular/core';

import { OriginConnectionPosition, OverlayConnectionPosition } from './connected-position';
import { ConnectedPositionStrategy } from './connected-position-strategy';
import { GlobalPositionStrategy } from './global-position-strategy';
import { ViewportRuler } from './viewport-ruler';

/** Builder for overlay position strategy. */
@Injectable()
export class OverlayPositionBuilder {
  constructor(private _viewportRuler: ViewportRuler) {}

  /** Creates a global position strategy. */
  public global(): GlobalPositionStrategy {
    return new GlobalPositionStrategy();
  }

  /** Creates a relative position strategy. */
  public connectedTo(
    elementRef: ElementRef,
    originPos: OriginConnectionPosition,
    overlayPos: OverlayConnectionPosition,
  ): ConnectedPositionStrategy {
    return new ConnectedPositionStrategy(elementRef, originPos, overlayPos, this._viewportRuler);
  }
}
